import { render } from "./CustomersTable.vue?vue&type=template&id=43eb72d3"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__